import { api } from '../../client';

export interface GeneralLedgerTransactionDto {
  id: string;
  date: string;
  entryId: string;
  entryNumber: string;
  accountId: string;
  accountCode: string;
  accountName: string;
  description: string;
  debit: number;
  credit: number;
  documents: { id: string; name: string; mimeType: string | null; size: number }[];
}

export interface GeneralLedgerResponseDto {
  transactions: GeneralLedgerTransactionDto[];
  totalDebits: number;
  totalCredits: number;
  transactionCount: number;
}

export const accountingGeneralLedgerApi = {
  async get(params: {
    account_id?: string;
    from_date?: string;
    to_date?: string;
  }): Promise<{ data?: GeneralLedgerResponseDto; message?: string }> {
    const sp = new URLSearchParams();
    if (params.account_id) sp.set('account_id', params.account_id);
    if (params.from_date) sp.set('from_date', params.from_date);
    if (params.to_date) sp.set('to_date', params.to_date);
    const q = sp.toString() ? `?${sp.toString()}` : '';
    return api.get(`/accounting/general-ledger${q}`) as Promise<{
      data: GeneralLedgerResponseDto;
      message?: string;
    }>;
  },
};
